import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { C } from '../../styles/tokens';

interface PaginationProps {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
  isLoading?: boolean;
  currentPage?: number;
  totalPages?: number;
}

const pillButtonStyle = (disabled: boolean): React.CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '8px 16px',
  fontSize: 13.5,
  fontWeight: 600,
  color: disabled ? C.n400 : C.n700,
  background: C.w,
  border: `1px solid ${C.n200}`,
  borderRadius: 999,
  cursor: disabled ? 'default' : 'pointer',
  transition: 'background-color .12s, border-color .12s',
});

const Pagination: React.FC<PaginationProps> = ({
  hasNextPage,
  hasPrevPage,
  onNextPage,
  onPrevPage,
  isLoading = false,
  currentPage,
  totalPages
}) => {
  const prevDisabled = !hasPrevPage || isLoading;
  const nextDisabled = !hasNextPage || isLoading;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 22,
        paddingTop: 14,
        borderTop: `1px solid ${C.n200}`,
      }}
    >
      <button
        onClick={onPrevPage}
        disabled={prevDisabled}
        style={pillButtonStyle(prevDisabled)}
        onMouseEnter={(e) => { if (!prevDisabled) e.currentTarget.style.background = C.n50; }}
        onMouseLeave={(e) => { if (!prevDisabled) e.currentTarget.style.background = C.w; }}
      >
        <ChevronLeft size={16} />
        Previous
      </button>

      {currentPage !== undefined && totalPages !== undefined && (
        <span style={{ fontSize: 13, color: C.n500 }}>
          Page {currentPage} of {totalPages}
        </span>
      )}

      <button
        onClick={onNextPage}
        disabled={nextDisabled}
        style={pillButtonStyle(nextDisabled)}
        onMouseEnter={(e) => { if (!nextDisabled) e.currentTarget.style.background = C.n50; }}
        onMouseLeave={(e) => { if (!nextDisabled) e.currentTarget.style.background = C.w; }}
      >
        Next
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default Pagination;
